<template>
  <div class="htmleditor-component-container">
    <div class="temp1" v-if="temp == 'k3Swiper'">
      <K3Swiper></K3Swiper>
    </div>
    <div class="temp1" v-if="temp == 'seltosSwiper'">
      <SeltosSwiper></SeltosSwiper>
    </div>
    <div class="temp1" v-if="temp == 'seltosUspSwiper'">
      <SeltosUspSwiper></SeltosUspSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev6FastLong'">
      <EV6FastLong></EV6FastLong>
    </div>
    <div class="temp1" v-if="temp == 'ev6Swiper1'">
      <EV6Swiper1></EV6Swiper1>
    </div>
    <div class="temp1" v-if="temp == 'ev6Swiper2'">
      <EV6Swiper2></EV6Swiper2>
    </div>
    <div class="temp1" v-if="temp == 'ev6Swiper3'">
      <EV6Swiper3></EV6Swiper3>
    </div>
    <div class="temp1" v-if="temp == 'ev6SwiperGtLine'">
      <ev6SwiperGtLine></ev6SwiperGtLine>
    </div>
    <div class="temp1" v-if="temp == 'ev6ImgSwiper'">
      <ev6ImgSwiper></ev6ImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev6SwiperXingneng'">
      <ev6SwiperXingneng></ev6SwiperXingneng>
    </div>
    <div class="temp1" v-if="temp == 'ev6OutInner'">
      <ev6OutInner></ev6OutInner>
    </div>
    <div class="temp1" v-if="temp == 'ev5Pics'">
      <ev5UspSwiper></ev5UspSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev5Gtline'">
      <ev5Gtline></ev5Gtline>
    </div>
    <div class="temp1" v-if="temp == 'ev5OutInner'">
      <ev5OutInner></ev5OutInner>
    </div>
    <div class="temp1" v-if="temp == 'ev5OutInnerGT'">
      <ev5OutInnerGT></ev5OutInnerGT>
    </div>
    <div class="temp1" v-if="temp == 'ev5AnimateNumber'" ref="targetElement">
      <ev5AnimateNumber ref="child"></ev5AnimateNumber>
    </div>
    <div class="temp1" v-if="temp == 'ev5ImgSwiper'">
      <ev5ImgSwiper></ev5ImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev5Swiper1'">
       <ev5VideopicstextSwiper></ev5VideopicstextSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev5gtline5Swiper1'">
      <ev5gtlineVideopicstextSwiper></ev5gtlineVideopicstextSwiper>
    </div>
    <div class="temp1" v-if="temp == 'ev5SwiperSafe'">
      <ev5SingleVideo></ev5SingleVideo>
    </div>
    <div class="temp1" v-if="temp == 'ev5SwiperVideo'">
      <ev5SwiperVideo></ev5SwiperVideo>
    </div>
    <div class="temp1" v-if="temp == 'sonetImgSwiper'">
      <sonetImgSwiper></sonetImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'sonetSingleVideo'">
      <sonetSingleVideo></sonetSingleVideo>
    </div>
    <div class="temp1" v-if="temp == 'sonetSwiperSafe'">
      <sonetSwiperSafe></sonetSwiperSafe>
    </div>
    <div class="temp1" v-if="temp == 'sonetSwiperSafe1'">
      <sonetSwiperSage1></sonetSwiperSage1>
    </div>
    <div class="temp1" v-if="temp == 'sonetSwiper1'">
       <sonetVideopicstextSwiper></sonetVideopicstextSwiper>
    </div>
    <div class="temp1" v-if="temp == 'sonetOutInner'">
      <sonetOutInner></sonetOutInner>
    </div>
    <div class="temp1" v-if="temp == 'k5ImgSwiper'">
      <k5ImgSwiper></k5ImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'sportageImgSwiper'">
      <sportageImgSwiper></sportageImgSwiper>
    </div>

    <div class="temp1" v-if="temp == 'sportageaceImgSwiper'">
      <aceImgSwiper></aceImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'kx1ImgSwiper'">
      <kx1ImgSwiper></kx1ImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'carnivalImgSwiper'">
      <carnivalImgSwiper></carnivalImgSwiper>
    </div>
    <div class="temp2" v-if="temp == 'newSportageSwiper1'">
      <newsportageVideopicstextSwiper></newsportageVideopicstextSwiper>
    </div>
    <div class="temp1" v-if="temp == 'newsportageImgSwiper'">
      <newSportageImgSwiper></newSportageImgSwiper>
    </div>
    <div class="temp1" v-if="temp == 'newsportageOutInner'">
      <newsportageOutInner></newsportageOutInner>
    </div>
  </div>
</template>

<script>

import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
import K3Swiper from "@/components/k3-swiper.vue";
import SeltosSwiper from "@/components/seltos-swiper.vue";
import SeltosUspSwiper from "@/components/seltos-usp-swiper.vue";
import EV6FastLong from "@/components/ev6-fast-long.vue";
import EV6Swiper1 from "@/components/ev6-swiper1.vue";
import EV6Swiper2 from "@/components/ev6-swiper2.vue";
import EV6Swiper3 from "@/components/ev6-swiper3.vue";
import ev6SwiperGtLine from "@/components/ev6-swiper-gt-line.vue";
import ev6SwiperXingneng from "@/components/ev6-swiper-xingneng.vue";
import ev6ImgSwiper from "@/components/ev6-imgs-swiper.vue";
import ev6OutInner from "@/components/ev6-out-inner.vue";
import newsportageOutInner from "@/components/newsportage-out-inner.vue";
import ev5OutInner from "@/components/ev5-out-inner.vue";
import ev5OutInnerGT from "@/components/ev5-out-inner-gtline.vue";
import ev5AnimateNumber from "@/components/ev5-animate-number.vue";
import ev5ImgSwiper from "@/components/ev5-imgs-swiper.vue";
import ev5VideopicstextSwiper from "@/components/ev5-videopicstext-swiper.vue";
import ev5gtlineVideopicstextSwiper from "@/components/ev5gtline-videopicstext-swiper";
import ev5SwiperVideo from "@/components/ev5-swiper-video.vue";
import ev5UspSwiper from "@/components/ev5-usp-swiper.vue";
import ev5Gtline from "@/components/ev5gtline-usp-swiper.vue";
import ev5SingleVideo from "@/components/ev5-single-video.vue";
import sonetImgSwiper from "@/components/sonet-imgs-swiper.vue";
import sonetSingleVideo from "@/components/sonet-single-video.vue";
import sonetSwiperSafe from "@/components/sonet-swiper-safe.vue";
import sonetSwiperSage1 from "@/components/sonet-swiper-safe1.vue"
import sonetVideopicstextSwiper from "@/components/sonet-videopicstext-swiper.vue";
import sonetOutInner from "@/components/sonet-out-inner.vue";
import k5ImgSwiper from "@/components/k5-imgs-swiper.vue";
import sportageImgSwiper from "@/components/sportage-imgs-swiper.vue";
import newSportageImgSwiper from "@/components/new-sportage-imgs-swiper.vue";
import aceImgSwiper from "@/components/sportageace-imgs-swiper.vue";
import kx1ImgSwiper from "@/components/kx1-imgs-swiper.vue";
import carnivalImgSwiper from "@/components/carnival-imgs-swiper.vue";
import newsportageVideopicstextSwiper from "@/components/newsportage-videopicstext-swiper.vue";
export default {
  name: 'index',
  components: {
    K3Swiper,
    SeltosSwiper,
    SeltosUspSwiper,
    EV6FastLong,
    EV6Swiper1,
    EV6Swiper2,
    EV6Swiper3,
    ev6SwiperGtLine,
    ev6ImgSwiper,
    ev6SwiperXingneng,
    ev6OutInner,
    ev5OutInner,
    ev5OutInnerGT,
    ev5AnimateNumber,
    ev5ImgSwiper,
    ev5VideopicstextSwiper,
    newsportageVideopicstextSwiper,
    ev5gtlineVideopicstextSwiper,
    ev5SwiperVideo,
    ev5UspSwiper,
    ev5Gtline,
    ev5SingleVideo,
    sonetImgSwiper,
    sonetSingleVideo,
    sonetSwiperSafe,
    sonetSwiperSage1,
    sonetVideopicstextSwiper,
    sonetOutInner,
    k5ImgSwiper,
    sportageImgSwiper,
    newSportageImgSwiper,
    aceImgSwiper,
    carnivalImgSwiper,
    kx1ImgSwiper,
    newsportageOutInner
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      temp: "", // 组件
    };
  },
  created: function () {
    this.temp = getUrlKey('temp')
  },
  mounted: function () {
    let e = this,
      t = document.querySelectorAll("[data-reveal-text]"); //全局文字动画
    0 !== t.length && t.forEach((function (t) {
      let i = t.children;
      gsap.from(i, {
        y: 200,
        opacity: 0.5,
        duration: 2000,
        stagger: .5,
        clearProps: "all",
        ease: e.EASE,
        scrollTrigger: {
          trigger: t,
          start: "top 90%",
          end: "top 90%",
          scrub: 1,
          // markers:true
        }
      })
    }))

    // window.addEventListener('scroll', this.handleScroll1, true)//滚动监听
  },
  methods: {
    handleScroll1() {
      const element = this.$refs.targetElement;
      console.log(element,'111')
      const rect = element.getBoundingClientRect();
      console.log(rect, '111')
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      console.log(window.innerHeight)
      console.log(scrollTop)
      if (rect.top + scrollTop < window.innerHeight) {
        this.$refs.child.showActive()
        this.startAnimation = true;
      }
    }
  }
}

</script>

<style lang="scss">
.htmleditor-component-container {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: #fff;
  height: 100%;

  .temp1 {
    height: 100%;
  }
  .temp2 {
    height: 100%;
    background-color: #D5D6D8;
  }
}
.ev5Swiper1{
    width: 100%;
    height: 50vw !important;
}
@media (max-width: 768px){
  .ev5Swiper1{
    height: 210vw !important;
  }
}
</style>
